import { CaseInfo, PreSalesCustomerInfo, defaultCaseInfo } from '../../dto/model';

/** Resolves the Booking OS display deal id for an HP case, falling back to the URL `crmId`. */
export const resolveHpDealId = (customerInfo: PreSalesCustomerInfo, crmId: string): string =>
  customerInfo.dealDetails?.dealId ? customerInfo.dealDetails.dealId.toString() : crmId;

/**
 * Maps a PreSales customer response into a display-only `CaseInfo` for the shared booking-page UI.
 * This is not an assigned Booking OS case, so `expireAt` stays null and assignment fields are empty.
 */
export const mapPreSalesCustomerInfoToCaseInfo = (
  customerInfo: PreSalesCustomerInfo,
  crmId: string,
  dealId: string,
): CaseInfo => {
  const personalDetails = customerInfo.personalDetails;

  return {
    ...defaultCaseInfo,
    internalId: crmId,
    opportunityId: dealId,
    // Keep the signup id empty when PreSales does not provide one. A CRM id is not a signup id,
    // and recordings are keyed on (and skipped without) a real signup id in the HP flow.
    signupId: customerInfo.signupId ?? '',
    globalCustomerId: customerInfo.gcid || customerInfo.customerId || '',
    caseId: crmId,
    firstName: personalDetails.firstName,
    lastName: personalDetails.lastName,
    email: personalDetails.email,
    street: personalDetails.street || personalDetails.address,
    houseNumber: personalDetails.housenumber,
    zipcode: personalDetails.zipCode,
    city: personalDetails.city,
    bookingStatus: '',
    caseComments: [],
    salesScript: '',
    salesObjections: [],
    expireAt: null,
    opportunityTags: [],
    qualifyingQuestions: [],
    showQualifyingQuestions: false,
  };
};
